module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-info",
    style: ({
      'height': _vm.deviceHeight
    })
  }, [_c('img', {
    staticClass: "edi-info-head",
    attrs: {
      "src": _vm.store.sysInfo && _vm.store.sysInfo.logo || ''
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "ui-listview"
  }, [_c('li', [_c('span', {
    staticClass: "ui-col-3"
  }, [_vm._v("企业名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyInfo.name),
      expression: "companyInfo.name"
    }],
    staticClass: "ui-col-7",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.companyInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.companyInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ui-col-3"
  }, [_vm._v("企业账号")]), _vm._v(" "), _c('span', {
    staticClass: "ui-col-7"
  }, [_vm._v(_vm._s(_vm.companyInfo.code))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ui-col-3"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyInfo.address),
      expression: "companyInfo.address"
    }],
    staticClass: "ui-col-7",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.companyInfo.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.companyInfo, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "ui-controlgroup",
    staticStyle: {
      "padding": "0 .5em"
    }
  }, [_c('input', {
    staticClass: "submit",
    attrs: {
      "type": "submit",
      "value": "保存修改"
    },
    on: {
      "click": _vm.modifySave
    }
  })]), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18708dab!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Infomation.vue
// module id = 539
// module chunks = 1